/** Consentimiento de cookies/analytics (Ley 19.628 — buenas prácticas). */

const STORAGE_KEY = 'soluqr_cookie_consent';
const EVENT_NAME = 'soluqr:cookie-consent-changed';

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_REJECTED = 'rejected';

/** @returns {'accepted'|'rejected'|null} */
export function getConsentStatus() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === CONSENT_ACCEPTED || raw === CONSENT_REJECTED) return raw;
    return null;
  } catch {
    return null;
  }
}

export function hasDecidedConsent() {
  return getConsentStatus() !== null;
}

/** Solo true si el usuario aceptó explícitamente cookies de analítica. */
export function hasAnalyticsConsent() {
  return getConsentStatus() === CONSENT_ACCEPTED;
}

function setConsent(value) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { status: value } }));
  } catch {
    /* ignore */
  }
}

export function acceptCookies() {
  setConsent(CONSENT_ACCEPTED);
}

export function rejectCookies() {
  setConsent(CONSENT_REJECTED);
}

/** Suscribe a cambios de consentimiento. Devuelve función de limpieza. */
export function onConsentChange(handler) {
  if (typeof window === 'undefined') return () => {};
  const wrapped = (e) => handler(e?.detail?.status ?? getConsentStatus());
  window.addEventListener(EVENT_NAME, wrapped);
  return () => window.removeEventListener(EVENT_NAME, wrapped);
}
